import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class WorkplaceGroup extends BaseModel {
  searchableProperties = ['name'];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);

    this.workplaces = rootStore.workplaceStore.getByIds(this.workplaceIds);
    this.defaultWorkplace = rootStore.workplaceStore.getById(this.defaultWorkplaceId);
  }
}

decorate(WorkplaceGroup, {
  id: observable,
  name: observable,
  defaultWorkplace: observable,
  defaultWorkplaceId: observable,
  workplaces: observable,
  workplaceIds: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  createdByUser: observable,
  updatedByUser: observable,
});
